import type { FC, PropsWithChildren, ReactElement } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twJoin, twMerge } from 'tailwind-merge'

export const FilterTabs: FC<PropsWithChildren<{ className?: string }>> & {
  Button: typeof FilterTabButton
} = ({ className, children }) => (
  <div className={twMerge('mb-6 flex overflow-hidden rounded-lg shadow-lg', className)}>
    {children}
  </div>
)

export const FilterTabButton: FC<{
  filterName: string | ReactElement
  isSelected: boolean
  whiteLabel?: WhiteLabel
  counter?: number
  onClick: () => void
  className?: string
}> = ({ isSelected, filterName, counter, whiteLabel: _whiteLabel, onClick, className }) => {
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'
  const whiteLabelClass = getWhiteLabelVariantColorClasses(isSelected)

  return (
    <button
      className={twMerge(
        'm-0 flex-[1_1_7rem] rounded-b-md border-0 border-b-[0.18rem] border-solid bg-white pb-3 pt-4 text-base transition duration-150 ease-out hover:cursor-pointer hover:border-b-[0.18rem] disabled:hover:border-b-white',
        !isSelected && 'border-b-transparent',
        whiteLabelClass[whiteLabel],
        className
      )}
      onClick={onClick}
    >
      {filterName} <span className="ml-2 font-bold">{counter}</span>
    </button>
  )
}

FilterTabs.Button = FilterTabButton

const getWhiteLabelVariantColorClasses = (
  isSelected: boolean
): Partial<Record<WhiteLabel, string>> => ({
  control: twJoin(
    'hover:border-b-skytech-orange hover:text-skytech-orange',
    isSelected && 'border-b-skytech-orange text-skytech-orange'
  ),
  skytech: twJoin(
    'hover:border-b-skytech-orange hover:text-skytech-orange',
    isSelected && 'border-b-skytech-orange text-skytech-orange'
  ),
  tcm: twJoin(
    'hover:border-b-skytech-orange hover:text-skytech-orange',
    isSelected && 'border-b-skytech-orange text-skytech-orange'
  ),
  arp: twJoin('hover:border-b-arp hover:text-arp', isSelected && 'border-b-arp text-arp'),
  mobit: twJoin('hover:border-b-mobit hover:text-mobit', isSelected && 'border-b-mobit text-mobit'),
  evry: twJoin(
    'hover:border-b-tietoevry hover:text-tietoevry',
    isSelected && 'border-b-tietoevry text-tietoevry'
  ),
  tietoevry: twJoin(
    'hover:border-b-tietoevry hover:text-tietoevry',
    isSelected && 'border-b-tietoevry text-tietoevry'
  ),
  bechtle: twJoin(
    'hover:border-b-bechtle hover:text-bechtle',
    isSelected && 'border-b-bechtle text-bechtle'
  ),
  csi: twJoin('hover:border-b-csi hover:text-csi', isSelected && 'border-b-csi text-csi'),
  telia: twJoin('hover:border-b-telia hover:text-telia', isSelected && 'border-b-telia text-telia'),
  elkjop: twJoin(
    'hover:border-b-elkjop hover:text-elkjop',
    isSelected && 'border-b-elkjop text-elkjop'
  ),
  threeStepIT: twJoin(
    'hover:border-b-threeStepIT hover:text-threeStepIT',
    isSelected && 'border-b-threeStepIT text-threeStepIT'
  ),
  komplett: twJoin(
    'hover:border-b-komplett hover:text-komplett',
    isSelected && 'border-b-komplett text-komplett'
  ),
})
